import { createRouter, createWebHashHistory } from 'vue-router'
import industriaRoutes from '@/modules/industria/routes'
import clientesRoutes from '@/modules/clientes/routes'
import campanhasRoutes from '@/modules/campanhas/routes'
import mobileRoutes from '@/modules/mobile/routes'
import errosRoutes from '@/modules/erros/routes'
import produtosRoutes from '@/modules/produtos/routes'
import usuariosRoutes from '@/modules/usuarios/routes'
import cercasVirtuaisRoutes from '@/modules/cercas-virtuais/routes'

const routes = [
  ...industriaRoutes,
  ...clientesRoutes,
  ...campanhasRoutes,
  ...mobileRoutes,
  ...errosRoutes,
  ...produtosRoutes,
  ...usuariosRoutes,
  ...cercasVirtuaisRoutes,
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.afterEach((to) => {
  document.title = to.meta?.title ? `${to.meta.title}` : 'Mercafacil'
})

export default router
